import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Invoice } from '../../types/company.types';
import { useAppQuery } from '../use-app-query.hook';

// Billing history lives on its own route rather than on the selected company: it costs a Stripe
// round trip per request, and every page loads the selected company during bootstrap.
export const useInvoices = ({
  companyId,
  enabled = true,
}: {
  companyId: string;
  enabled?: boolean;
}) => {
  const { data: invoices, isLoading } = useAppQuery<Invoice[]>({
    queryKey: [QueryKey.GET_COMPANY_INVOICES, companyId],
    queryFn: () =>
      ApiService.get({ endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'invoices'] }),
    enabled: !!companyId && enabled,
  });

  return { invoices, isLoading };
};
